'use client';

import {PrivyProvider} from '@privy-io/react-auth';
import {SmartWalletsProvider} from "@privy-io/react-auth/smart-wallets";
import React from "react";
import {ReduxProvider} from "@/lib/redux/Provider";
import {StyleSheetManager} from "styled-components";

type ProvidersProps = Readonly<{ children: React.ReactNode }>;

export default function Providers({children}: ProvidersProps) {
    return (
        <StyleSheetManager shouldForwardProp={(propName) => !['stacked', 'isActive'].includes(propName)}>
            <ReduxProvider>
                <PrivyProvider
                    appId={process.env.NEXT_PUBLIC_META_ANCHOR_PRIVY_APP_ID || ''}
                    clientId={process.env.NEXT_PUBLIC_META_ANCHOR_PRIVY_CLIENT_ID || ''}
                    config={{
                        embeddedWallets: {
                            ethereum: {
                                createOnLogin: 'users-without-wallets'
                            }
                        },
                        appearance: {
                            theme: 'dark',
                            accentColor: '#676FFF',
                            landingHeader: '',
                            loginMessage: 'Please log in with your email you sent the NFTs to.',
                            showWalletLoginFirst: false,
                            logo: 'logo.png',
                        }
                    }}>
                    <SmartWalletsProvider>
                        {children}
                    </SmartWalletsProvider>
                </PrivyProvider>
            </ReduxProvider>
        </StyleSheetManager>
    );
}